import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// BrickmouldType — shown when Brickmould is Loose or Installed
const OPTIONS = [
  { value: 'Standard',        label: 'Standard'         },
  { value: 'ContemporaryFlat', label: 'Contemporary Flat' },
];

const BrickmouldType = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdBrickmouldType">Brickmould Type</label>
      <select id="SdBrickmouldType" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BrickmouldType;
